import type { OperationsTeamNode } from '../types/operations.types'

export interface SeedPlacement {
  seed_action: 'before' | 'after'
  destination_team_id?: string
}

/**
 * Where a dragged team lands, expressed the only way the API accepts it.
 *
 * There is no absolute-seed write endpoint: `PUT /schedules/:id/teams/:id/move`
 * takes a RELATIVE placement against a neighbouring team. This is a direct port
 * of the legacy Setup tab (ScheduleTree/index.jsx:709-727) so both tabs reseed
 * identically.
 *
 * `siblings` is the destination list AFTER the drop, including the dragged team.
 * `seed_action` is always present — legacy sends it even when there is no
 * destination team, and the API requires the field.
 */
export const resolveSeedPlacement = (
  siblings: OperationsTeamNode[],
  draggedNodeId: string
): SeedPlacement => {
  if (siblings.length <= 1) {
    return { seed_action: 'after' }
  }

  const index = siblings.findIndex((sibling) => sibling.id === draggedNodeId)
  if (index === -1) {
    return { seed_action: 'after' }
  }

  if (index === 0) {
    return { seed_action: 'before', destination_team_id: siblings[1].teamId }
  }

  if (index === siblings.length - 1) {
    return {
      seed_action: 'after',
      destination_team_id: siblings[siblings.length - 2].teamId,
    }
  }

  return {
    seed_action: 'before',
    destination_team_id: siblings[index + 1].teamId,
  }
}
